import CommerceConnector from './code/Scripts/components/commerce-connector/commerce-connector.vue';

export default {
  components: {
    CommerceConnector,
  },
};
